import { render } from "./BindView.vue?vue&type=template&id=06b70149&scoped=true"
import script from "./BindView.vue?vue&type=script&lang=js"
export * from "./BindView.vue?vue&type=script&lang=js"

import "./BindView.vue?vue&type=style&index=0&id=06b70149&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b70149"]])

export default __exports__